import React from 'react';
export default function Blockquote(props) {
  return /*#__PURE__*/React.createElement("blockquote", {
    "data-local-id": props.localId
  }, props.children);
}